export const serviceData = {
  'custom-web-development-company': {
    title: 'Custom Web Development Company & Services',
    metaDescription: 'Expert custom web development services. We build scalable, high-performance web applications using React and Next.js.',
    heroTitle: 'Custom Web Application Development Services',
    heroDescription: 'Full-Stack Web Development Solutions specializing in React and Next.js for startups and enterprises.',
    technologies: ['React', 'Next.js', 'Node.js', 'TypeScript', 'Tailwind CSS', 'Vite'],
    benefits: ['Sub-second Load Times', 'SEO-Optimized Architecture', 'Responsive Mobile-First Design', 'Scalable Backend Integration'],
    faq: [
      { q: 'What technologies do you use for web development?', a: 'We specialize in modern JavaScript frameworks including React, Next.js, and Vite, backed by robust APIs using Node.js and Python.' },
      { q: 'Is the code SEO friendly?', a: 'Absolutely. We implement semantic HTML, SSR/SSG, and Core Web Vitals optimization.' }
    ],
    process: [
      { title: 'Discovery & Architecture', desc: 'We blueprint the optimal tech stack and database schema for your specific business logic.' },
      { title: 'UI/UX Engineering', desc: 'Premium Figma designs converted into pixel-perfect, responsive React components.' },
      { title: 'Backend & API Integration', desc: 'Secure, scalable endpoints and robust database engineering.' },
      { title: 'Testing & Deployment', desc: 'Rigorous QA, speed optimization, and seamless cloud deployment.' }
    ],
    useCases: ['SaaS Platforms', 'E-commerce Marketplaces', 'Enterprise Dashboards', 'Corporate Web Portals'],
    caseStudy: {
      title: 'Global Travel Booking Engine',
      metric: '+85% Increase in Mobile Conversions',
      desc: 'Re-engineered a legacy portal into a high-speed Next.js platform, slashing load times and skyrocketing user engagement.'
    },
    internalLink: {
      text: 'Looking to build a product from scratch? Check out our ',
      linkText: 'SaaS Development',
      href: '/services/saas-development-company',
      postText: ' expertise to get your MVP launched fast.'
    }
  },
  'ai-automation-services': {
    title: 'AI Automation Services & Solutions Company',
    metaDescription: 'Transform your business workflows with our AI automation services. We integrate LLMs, custom chatbots, and machine learning models.',
    heroTitle: 'Intelligent AI Automation Services for Modern Businesses',
    heroDescription: 'Custom intelligent workflows and LLM-powered systems designed to automate operations and drastically scale your business.',
    technologies: ['OpenAI API', 'LangChain', 'Python', 'Pinecone', 'TensorFlow', 'Make', 'Node.js'],
    benefits: ['Custom LLM Integration', 'Workflow Automation', '24/7 Intelligent Chatbots', 'Data-Driven Insights'],
    faq: [
      { q: 'Can AI replace my manual processes?', a: 'AI can automate up to 80% of repetitive operational tasks, freeing your team for strategic work.' },
      { q: 'Is it secure?', a: 'We build secure, private instances of AI models tailored to your enterprise data.' }
    ],
    process: [
      { title: 'Workflow Audit', desc: 'We analyze your current operations to identify high-ROI automation bottlenecks.' },
      { title: 'AI Model Selection', desc: 'Choosing the right foundational models (GPT-4, Claude) for your specific data.' },
      { title: 'Custom Integration', desc: 'Connecting AI agents directly into your CRM, ERP, and internal databases.' },
      { title: 'Continuous Training', desc: 'Refining prompts and fine-tuning models based on real-world usage.' }
    ],
    useCases: ['Automated Customer Support', 'Data Extraction & Parsing', 'Dynamic Content Generation', 'Predictive Analytics'],
    internalLink: {
      text: 'A custom AI system needs a scalable backend. Explore our ',
      linkText: 'Custom Software',
      href: '/services/custom-software-development',
      postText: ' solutions for robust infrastructure.'
    }
  },
  'mobile-app-development-company': {
    title: 'Mobile App Development Company | iOS & Android Apps',
    metaDescription: 'Top mobile app development company. We engineer high-performance cross-platform apps using Flutter for iOS and Android.',
    heroTitle: 'Cross-Platform Mobile App Development Services',
    heroDescription: 'We engineer high-performance cross-platform apps using Flutter for iOS and Android, ensuring enterprise mobility.',
    technologies: ['Flutter', 'React Native', 'Firebase', 'Dart', 'Swift', 'Kotlin', 'Node.js'],
    benefits: ['Single Codebase for iOS & Android', 'Native Performance', 'Custom UI/UX Animations', 'Offline Functionality'],
    faq: [
      { q: 'Do you build for both iOS and Android?', a: 'Yes, we use cross-platform frameworks like Flutter to deploy to both App Store and Google Play simultaneously.' },
      { q: 'Can you integrate third-party APIs?', a: 'Yes, we build robust backend integrations with payment gateways, CRMs, and custom hardware APIs.' }
    ],
    process: [
      { title: 'App Blueprinting', desc: 'Defining the core feature set and mapping user journeys.' },
      { title: 'Wireframing & Prototyping', desc: 'Creating interactive Figma prototypes for both mobile platforms.' },
      { title: 'Cross-Platform Engineering', desc: 'Writing clean, scalable code using Flutter or React Native.' },
      { title: 'App Store Deployment', desc: 'Handling all strict Apple and Google review processes for seamless launch.' }
    ],
    useCases: ['Fintech Applications', 'On-Demand Services', 'Social Networks', 'Internal Enterprise Tools'],
    caseStudy: {
      title: 'Religious Community App',
      metric: '10k+ Active Global Users',
      desc: 'Built a highly performant Flutter app serving an international audience with offline-first capabilities.'
    },
    internalLink: {
      text: 'Are you a startup launching a mobile product? Read about our ',
      linkText: 'Startup MVP Development',
      href: '/services/saas-development-company',
      postText: ' approach.'
    }
  },
  'custom-software-development': {
    title: 'Custom Software Development Company',
    metaDescription: 'Bespoke custom software development solutions tailored to your unique business logic, focusing on scalability and security.',
    heroTitle: 'Enterprise Custom Software Development Solutions',
    heroDescription: 'Scalable backend architectures, API development, and enterprise dashboards tailored exactly to your complex operational needs.',
    technologies: ['Node.js', 'Python', 'PostgreSQL', 'Docker', 'AWS', 'Redis', 'GraphQL'],
    benefits: ['Microservices Architecture', 'Secure API Gateways', 'Custom CRM/ERP Systems', 'Cloud Infrastructure'],
    faq: [
      { q: 'Do you build from scratch?', a: 'Yes, we architect custom solutions precisely tailored to your business logic without forcing rigid templates.' },
      { q: 'Can it scale?', a: 'We utilize cloud-native infrastructure (AWS, Docker) to ensure your software handles infinite scaling.' }
    ],
    process: [
      { title: 'Requirements Engineering', desc: 'Mapping out every edge case and business rule before writing a single line of code.' },
      { title: 'System Architecture', desc: 'Designing secure, scalable databases and resilient API microservices.' },
      { title: 'Agile Development', desc: 'Iterative two-week sprints providing continuous transparency and flexibility.' },
      { title: 'DevOps & Maintenance', desc: 'Automated CI/CD pipelines and 24/7 monitoring for zero downtime.' }
    ],
    useCases: ['Custom CRM & ERPs', 'Supply Chain Management', 'Fintech Dashboards', 'Healthcare Portals'],
    internalLink: {
      text: 'Need an online presence for your software? View our ',
      linkText: 'Web Development',
      href: '/services/custom-web-development-company',
      postText: ' capabilities.'
    }
  },
  'saas-development-company': {
    title: 'SaaS Development Company & Agency | Build Your MVP',
    metaDescription: 'We are a specialized SaaS development company helping startups and enterprises launch scalable, multi-tenant software platforms.',
    heroTitle: 'End-to-End SaaS Platform Development Services',
    heroDescription: 'From startup MVP to enterprise multi-tenant architectures, we build SaaS products that scale and generate revenue.',
    technologies: ['React', 'Next.js', 'Stripe', 'Node.js', 'PostgreSQL', 'AWS', 'Firebase'],
    benefits: ['Multi-Tenant Architecture', 'Stripe Subscription Integration', 'Rapid MVP Launch', 'Role-Based Access Control'],
    faq: [
      { q: 'How fast can you build a SaaS MVP?', a: 'We focus on core features and can launch a testable SaaS MVP within 6 to 12 weeks.' },
      { q: 'Do you handle payment gateways?', a: 'Yes, we are experts at integrating Stripe and PayPal for complex subscription and usage-based billing.' }
    ],
    process: [
      { title: 'Product Scoping', desc: 'Defining the MVP feature set to minimize time-to-market.' },
      { title: 'Tenant Architecture', desc: 'Designing secure database schemas that separate user data safely.' },
      { title: 'Core Development', desc: 'Building the application logic, authentication, and billing systems.' },
      { title: 'Beta Launch', desc: 'Deploying to staging environments for initial user testing and feedback.' }
    ],
    useCases: ['B2B SaaS Products', 'Marketplaces', 'Internal Tools', 'Subscription Portals'],
    caseStudy: {
      title: 'B2B Analytics Platform',
      metric: '$50k+ MRR Generated',
      desc: 'Architected a multi-tenant React application that processed millions of data points with zero latency.'
    },
    internalLink: {
      text: 'SaaS products require strong technical foundations. Review our ',
      linkText: 'Custom Software Development',
      href: '/services/custom-software-development',
      postText: ' methodologies.'
    }
  }
};
